import { Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PTErrors, PTInfo, PTInputSelect, PTInputSelectBasic, PTInputTextArea, PTInputCheckbox } from '../../components/PTElements';
import { notificationChoreType, when_Automated } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/notificationchores";
import './NotificationChoreDetails.css';
import { Question } from './Question';

export const NCD6 = (props) => {
    const { values, setFieldValue } = useFormikContext();
    const [variable, setVariable] = useState('');
    const [appointmentModelProperties, setappointmentModelProperties] = useState([]);
    const [caret, setCaret] = useState(-1);
    const [charLength, setCharLength] = useState(0);
    const [smsCount, setSmsCount] = useState(0);

    useEffect(() => {
        if (props && EVO.any(props.appointmentModelProperties)) {
            const modelProps = props.appointmentModelProperties.filter(p => {
                return !EVO.any(p.whenAutomatedHide, a => a === values.whenAutomatedId);
            });

            setappointmentModelProperties(modelProps);
        }
    }, [props.appointmentModelProperties]);

    const addVariable = (value) => {
        var carPos = caret;
        if (caret < 0 || caret > values.messageTemplate.length)
            carPos = values.messageTemplate.length;

        var temp = values.messageTemplate.substring(0, carPos) + `[${value}]` + values.messageTemplate.substring(carPos);
        setFieldValue('messageTemplate', temp);
        setVariable('');
    }

    const handleMessageTempleChange = (e, setFieldValue) => {
        var temp = e.target.value;
        if (temp) {
            temp = temp.replace(/[^A-Za-z0-9 \r\n@£$¥!"#$%&amp;'()*+,_.\-/:;<=>?^{}\\[~\]]*/ig, '');
        }
        setFieldValue('messageTemplate', temp);
        setCaret(e.target.selectionEnd);
    }

    const handleClick = (e) => {
        setCaret(e.target.selectionEnd);
    };

    useEffect(() => {
        var length = 0;
        if (values.messageTemplate) {
            length = values.messageTemplate.length;
        }

        if (values.marketing) {
            length += 50;
        }

        const numberOfSms = Math.floor(length / 160) + 1;

        setSmsCount(numberOfSms);
        setCharLength(length);
    }, [values.messageTemplate]);

    return (<div>
        {
            values.notificationType === notificationChoreType.Email ? <div>
                <Question>Which template should it send?</Question>
                <span className="ncd-email-template-subtest">To edit a template go to the Send Email tab and click on ‘Transactional’ in the top menu. <a href="https://help.peptalkr.com.au/en/articles/4151881-how-to-edit-your-transactional-email-content" target="_blank" rel="noopener noreferrer">More info</a></span>
                <Field name="cmEmailId" component={PTInputSelect} options={props.cmEmails} center='true' />
                <PTErrors fields={['cmEmailId']} />
                {values.whenAutomatedId === when_Automated.AfterCreated.value && <div className="ncd-attach-ics">
                    <Field name="attachIcsFile" component={PTInputCheckbox} center='true' placeholder="Attach ICS file for appointment" />
                </div>}
            </div> :
                <div>
                    <Question>What should the SMS say?</Question>
                    <Field name="messageTemplate" component={PTInputTextArea} placeholder="" center='true' onChange={(e) => handleMessageTempleChange(e, setFieldValue)} onClick={(e) => handleClick(e)} />
                    <AdditionalQuestion>
                        <div>Approx characters used: {charLength} {smsCount > 1 && <span className="messageTemplate-count-warning">({smsCount} messages)</span>}</div>
                        
                        <div className="ncd-variables-wrapper">
                            <div className="ncd-variables">available variables<PTInfo info={`Variables insert information specific to the recipient into your SMS. Variables can extend the length of your message and may use more credits.`} /></div>
                            {props.appointmentModelProperties && <div>
                                <PTInputSelectBasic
                                    field={{ name: '', value: variable }}
                                    options={appointmentModelProperties}
                                    classNamePrefix="pt-input-select"
                                    placeholder="Select..."
                                    onChange={e => {
                                        addVariable(e.value);
                                        //e.stopPropagation();
                                    }}
                                />
                            </div>}
                        </div>
                    </AdditionalQuestion>
                    <PTErrors fields={['messageTemplate']} />
                    {values.marketing && <div className="messageTemplate-marketing-message">
                        <span>*Please note that because this is a marketing SMS, an opt out link will be added to the end of the SMS and may cause the character count to increase. The typical link length is around 50 characters, and this has been added to the estimate above.</span>
                    </div>}
                    {values.messageTemplate && values.messageTemplate.indexOf('[telehealthlink]') > -1 && <div className="messageTemplate-marketing-message">
                        <span>*Note - Please ensure you have telehealth enabled on all appointment types using this.</span>
                    </div>}
                </div>
        }
    </div>
    );
}

const AdditionalQuestion = ({ children }) => {
    return (<div className="ncd-additional-question">{children}</div>);
};

const mapStateToProps = ({ ensure }) => ({
    appointmentModelProperties: ensure.appointmentModelProperties,
    cmEmails: ensure.cmEmails
});

export const NcdStep6 = connect(mapStateToProps, actions)(NCD6);


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NcdStep6.js